import React, { Component } from 'react';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import Checkbox from '@material-ui/core/Checkbox';
import { hide } from 'store/modules/modal';
import _ from 'lodash';

export class StopScreenDialog extends Component {
  state = {
    selectedScreen: [],
  };
  constructor(props) {
    super(props);
    const { interaction } = this.props;
    const questions = _.get(interaction, 'params.questions', []);
    let selectedScreenTemp = this.state.selectedScreen;
    questions.forEach((question, idx) => {
      if (question.stopped) {
        selectedScreenTemp.push(idx);
      }
    });
    this.setState({ selectedScreen: selectedScreenTemp });
  }
  handleChange = (event, indexQuestion) => {
    let selectedScreenTemp = this.state.selectedScreen;

    if (!selectedScreenTemp.includes(indexQuestion)) {
      selectedScreenTemp.push(indexQuestion);
    } else {
      _.remove(selectedScreenTemp, elem => elem === indexQuestion);
    }

    this.setState({ selectedScreen: selectedScreenTemp });
  };

  render() {
    const { opened, dispatch, handleOk, interaction, message } = this.props;

    const questions = interaction.params.questions;
    return (
      <div>
        <Dialog open={opened} onClose={() => dispatch(hide())}>
          <DialogTitle>{message}</DialogTitle>
          <DialogContent>
            {questions &&
              questions.map((question, idx) => {
                if (question.key.startsWith('_q')) {
                  return (
                    <FormControl component="fieldset" key={idx}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={event => this.handleChange(event, idx)}
                              name={question.title}
                              checked={this.state.selectedScreen.includes(idx)}
                            />
                          }
                          label={question.title}
                        />
                      </FormGroup>
                    </FormControl>
                  );
                }
                return null;
              })}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                dispatch(hide());
              }}
              color="secondary"
            >
              CANCEL
            </Button>
            <Button
              onClick={() => {
                dispatch(handleOk(this.state.selectedScreen));
                dispatch(hide());
              }}
              color="primary"
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    opened: state.modal.opened,
  };
};

export default connect(mapStateToProps)(StopScreenDialog);
